export default __webpack_public_path__ + "assets/images/54557260ff80c3d8a78092d826dad586.png";